import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // getToken from cookie

NProgress.configure({ showSpinner: false })// NProgress configuration

const whiteList = ['/detail/index', "/index","/index2", "/issues/index", "/callback","/introduce/index","/manhuang"] // 不重定向白名单
// main.js
router.beforeEach((to, from, next) => {
  if (getToken()) { // 判断是否有token
    next()
  } else {
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next('/index')
      store.dispatch("clickLogin", true);
    }
  }
})
router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js